import { mdiFileOutline, mdiFolder, mdiFolderOpen } from '@mdi/js'

/**
 * Per-tree icon overrides for {@link HierarchyTree} rows.
 *
 * Consumers whose nodes are *all* the same kind of thing (folder-layout
 * folders, for instance) swap the defaults here instead of setting `icon` on
 * every single node. Anything left undefined keeps the historical default, so
 * existing consumers (`DocumentTypesTree`, the `/$org/patterns` demo) are
 * unaffected.
 */
export interface HierarchyTreeIcons {
    /** Node with no children. Default `mdiFileOutline`. */
    leaf?: string
    /** Node with children, currently collapsed. Default `mdiFolder`. */
    collapsed?: string
    /** Node with children, currently expanded. Default `mdiFolderOpen`. */
    expanded?: string
}

/**
 * Resolves the MDI path for one row.
 *
 * Priority: the node's own `icon` (highest, unchanged) → the tree-level
 * `icons` override for the row's state → the historical default.
 */
export function resolveTreeIcon(
    nodeIcon: string | undefined,
    hasChildren: boolean,
    isExpanded: boolean,
    icons?: HierarchyTreeIcons
): string {
    if (nodeIcon) return nodeIcon
    if (!hasChildren) return icons?.leaf || mdiFileOutline
    if (isExpanded) return icons?.expanded || mdiFolderOpen
    return icons?.collapsed || mdiFolder
}
